export enum BannerTypes {
  error = 'error',
  warning = 'warning',
  success = 'success',
  information = 'information',
}
